import {
  Box,
  Text,
} from '@chakra-ui/react';
import React from 'react';

export default function SidebarDocs() {
  return (<Box height={'10px'}/>);
}
